<template lang="pug">
  .table-responsive
    table#tbProveedores.table.is-striped.is-fullwidth
      thead
        tr
          th.is-size-6
            | #
          th.is-size-6
            | Proveedor
          th.is-size-6
            | Dirección
          th.is-size-6
            | Contacto
      tbody
        tr(v-for="(prov, index) in proveedores" :key="prov.id")
          td
            a.button.is-black.is-rounded.is-small(@click="editarProveedor(prov)")
              | {{ index + 1 }}
          td(v-html="convertirReferencias(prov)")
          td(v-html="convertDireccion(prov)")
          td(v-html="convetirContacto(prov)")
</template>

<script>
  export default {
    name: 'Tb_Proveedores',
    props: {
      proveedores: {
        type: Array,
        default: []
      },
    },

    methods: {
      convertDireccion(dir) {
        let html = `<small>${dir.calle} #${dir.numExt}, ${dir.colonia}, ${dir.ciudad}</small><br />
        <small>${dir.estado}, ${dir.pais} ~ C.P. ${dir.cp} ~ Tel. ${dir.telefono1}</small><br />
        `
        return html
      },
      convetirContacto(dir) {
        let html = `
        <span class="tag is-ligth">${dir.contacto}</span><br />
        <a href="mailto:${dir.correo}">
          <i class="far fa-envelope"></i>&nbsp${dir.correo}
        </a>
        `
        return html
      },
      convertirReferencias(dir) {
        let html = `
            <div class="control">
              <span class="tag is-black">${dir.nombre}</span>
            </div>
            <div class="control is-tag-top">
              <div class="tags has-addons">
                <span class="tag">R.F.C.</span>
                <span class="tag">${dir.rfc}</span>
              </div>
            </div>
            <div class="control is-tag-top">
              <div class="tags has-addons">
                <span class="tag">CLABE:</span>
                <span class="tag">${dir.clabeInterbancaria}</span>
              </div>
            </div>
            <div class="control is-tag-top">
              <span class="tag is-info">${dir.banco}</span>
            </div>
        `
        return html
      },
      editarProveedor(prov) {
        this.$emit('editarProv', prov)
      }
    },
  }
</script>

<style lang="css" scoped>
  .control .is-tag-top {
    margin-top: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/Tb_Proveedores.vue